import React, { useEffect, useState } from 'react'
import * as S from './styles'

import Availability from '@/components/LandingPage/Availability'
import NewModuleTag from '@/components/LandingPage/NewModuleTag'

import { useTranslation } from 'react-i18next'

const DetailsSubItem = ({ index, data }) => {
  const { t } = useTranslation()

  const [title, setTitle] = useState('')
  const [text, setText] = useState('')

  useEffect(() => {
    if (!data) return
    setTitle(t(data.title))
    setText(t(data.text))
  }, [t, data])

  return (
    data && (
      <S.DetailsSubItemContainer id={`section-subitem-${index}`}>
        <div className="flexbox v-centered mb-4">
          <h3>{title}</h3>
          {data.newUntil && <NewModuleTag expDate={data.newUntil} />}
        </div>
        <p>{text}</p>
        {data.customComponent && <data.customComponent />}
        {data.available && (
          <Availability platforms={data.available} className="mt-5" />
        )}
        <div className="flexbox v-centered h-centered pb-5 pt-5">
          {data.image && <img src={data.image} alt="" />}
          {data.video && (
            <video preload="auto" playsInline loop muted autoPlay>
              <source type="video/mp4" src={data.video} />
              Your browser does not support the video tag.
            </video>
          )}
        </div>
      </S.DetailsSubItemContainer>
    )
  )
}

export default DetailsSubItem
